import { createI18n } from "vue-i18n";
import en from "./en.json";
import fr from "./fr.json";

export type Locale = "fr" | "en";

export const LOCALE_DEFAUT: Locale = "fr";
export const CLE_STOCKAGE_LOCALE = "portail-locale";

function estLocale(valeur: string | null): valeur is Locale {
  return valeur === "fr" || valeur === "en";
}

/** Locale retenue de la visite précédente ; le français par défaut. */
export function localeInitiale(): Locale {
  try {
    const memorisee = window.localStorage.getItem(CLE_STOCKAGE_LOCALE);
    if (estLocale(memorisee)) {
      return memorisee;
    }
  } catch {
    // Stockage indisponible : le français reste le défaut.
  }
  return LOCALE_DEFAUT;
}

/** Pose la langue sur la page, pour les lecteurs d'écran et la traduction du navigateur. */
export function appliquerLangue(locale: Locale): void {
  document.documentElement.setAttribute("lang", locale);
}

export function memoriserLocale(locale: Locale): void {
  try {
    window.localStorage.setItem(CLE_STOCKAGE_LOCALE, locale);
  } catch {
    // La langue change quand même : seule la mémoire d'une visite à l'autre est perdue.
  }
  appliquerLangue(locale);
}

export function creerI18n(locale: Locale = localeInitiale()) {
  return createI18n({
    legacy: false,
    locale,
    fallbackLocale: LOCALE_DEFAUT,
    messages: { fr, en },
  });
}
